import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { AdminAccess } from '../../../shared/accessAdmin';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { ListGridAsyncData } from '../../../shared/listGrid/listGrid.component';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent implements OnInit, OnDestroy, ContainsSubscriptions {
  public columnDefs;
  public rowData;
  public editPath;
  public subs: Subscription[] = [];
  public page = 0;
  public dataLoading = true;
  public count: number;
  public limit = 50;
  public numberOfPages: number;
  listGridAsyncData = new BehaviorSubject<ListGridAsyncData>({
    count: 0,
    page: 0,
    rows: [],
    searchQuery: null,
    numberOfPages: null,
    sortBy: null,
    sortOrder: null,
  });

  constructor(
    private router: Router,
    public userDAO: UserDAO,
    private apiHelper: ApiHelper,
    private checkAdmin: AdminAccess,
  ) {
    this.editPath = 'manage/admin/user/edit';

    this.checkAdmin.checkAdminAccess(this.userDAO, this.apiHelper, this.router);
  }

  ngOnInit() {
    this.initAsyncData();
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  private createColumnDefs() {
    return [
      {
        headerName: 'email',
        field: 'email',
        filter: 'text',
      },
      {
        headerName: 'First Name',
        field: 'firstName',
        filter: 'text',
      },
      {
        headerName: 'Last Name',
        field: 'lastName',
        filter: 'text',
      },
      {
        headerName: 'Phone Number',
        field: 'phoneNumber',
        filter: 'text',
      },
      {
        headerName: 'Created',
        field: 'createdAt',
        filter: 'date',
      },
      {
        headerName: 'Status',
        field: 'status',
        filter: 'text',
      },
      {
        headerName: 'Email Verified',
        field: 'emailVerified',
        filter: 'boolean',
        minWidth: 50,
      },
      {
        headerName: 'Phone Verified',
        field: 'phoneConfirmed',
        filter: 'boolean',
        minWidth: 50,
      },
      {
        headerName: 'Accepted Code',
        field: 'acceptedAnchorCode',
        filter: 'boolean',
        minWidth: 50,
      },
    ];
  }

  private initAsyncData(): void {
    const { searchQuery, sortOrder, sortBy } = this.listGridAsyncData.value;
    const sub = this.userDAO
      .loadAdminGridUsers(this.page, searchQuery, sortBy, sortOrder)
      .subscribe((usersAndCount) => {
        this.count = usersAndCount.count;
        this.columnDefs = this.createColumnDefs();
        this.listGridAsyncData.next({
          rows: usersAndCount.rows,
          count: usersAndCount.count,
          page: this.page,
          searchQuery: searchQuery,
          numberOfPages: Math.floor(usersAndCount.count / this.limit),
          sortOrder: sortOrder,
          sortBy: sortBy,
        });
        this.dataLoading = false;
      });
    this.subs.push(sub);
  }

  pageChange($event: number) {
    this.page = $event;
    this.initAsyncData();
  }
}

export interface AdminUserGrid {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  createdAt: string;
  status: string;
  emailVerified: boolean;
  phoneConfirmed: boolean;
  acceptedAnchorCode: boolean;
}
